var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSuitcase = function SvgSuitcase(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 3V1h6v2h5v11H0V3h5zm1 6.81l-5-2.5V13h14V7.31l-5 2.5V11H6V9.81zm0-1.12V8h4v.69l5-2.5V4H1v2.19l5 2.5zM7 10h2V9H7v1zM6 3h4V2H6v1z",
    fillRule: "nonzero"
  })));
};
export default SvgSuitcase;